module.exports = __webpack_public_path__ + "img/polline-00.2a8e74ab.jpg";